<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <div
        class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <div>
                <div class="flex">
                    <a class="inline-flex items-center -ml-1.5 text-secondary font-medium"
                        [routerLink]="'/profile-detail'">
                        <mat-icon class="icon-size-5 text-secondary"
                            [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                        <span class="ml-1">Back</span>
                    </a>
                </div>
            </div>
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    {{ isEditMode ? 'Edit Profile' : 'Profile' }}
                </h2>
            </div>
        </div>
        <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <button *ngIf="!isEditMode && countAdmin === 1" class="px-8" mat-raised-button color="primary"
                (click)="toggleEditMode()">
                Edit
            </button>
        </div>
    </div>

    <div class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card" cdkScrollable>
        <!-- Details View -->
        <div *ngIf="!isEditMode" class="p-6 sm:p-10">
            <h2 class="text-lg sm:text-xl font-semibold text-gray-800 mb-4 border-b pb-2 p-4 ">
                Staff Information
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Is Active</label>
                    <mat-checkbox [(ngModel)]="staffData.Is_Active__c" color="primary" disabled="EditMode">
                    </mat-checkbox>
                </div>
                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Staff ID</label>
                    <p class="text-lg text-gray-600">{{ staffData?.Name || '--' }}</p>
                </div>

                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Staff Name</label>
                    <p class="text-lg text-gray-600">{{ staffData?.Staff_Name__c || '--' }}</p>
                </div>

                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Email</label>
                    <p class="text-lg text-gray-600">{{ staffData?.Staff_Email__c || '--' }}</p>
                </div>

                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Phone</label>
                    <p class="text-lg text-gray-600">{{ staffData?.Staff_Phone__c || '--' }}</p>
                </div>

                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Role</label>
                    <p class="text-lg text-gray-600">{{ staffData?.Role__c || '--' }}</p>
                </div>

                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Address</label>
                    <p class="text-lg text-gray-600">{{ staffData?.Staff_Address__c || '--' }}</p>
                </div>
            </div>
            <div *ngIf="countAdmin > 0" class="flex flex-col gt-xs:flex-row">
                <h2 class="text-lg sm:text-xl font-semibold text-gray-800 mb-4 border-b pb-2 p-4 ">
                    Staff Role Permissions
                </h2>
                <table mat-table [dataSource]="staffPermissions" class="mat-elevation-z2 w-full text-sm">
                    <ng-container matColumnDef="feature">
                        <th mat-header-cell *matHeaderCellDef> Feature </th>
                        <td mat-cell *matCellDef="let permission" class="text-md font-semibold text-gray-800 ">
                            {{permission.feature}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef> View </th>
                        <td mat-cell *matCellDef="let permission">
                            <mat-checkbox [checked]="permission.view" disabled></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="create">
                        <th mat-header-cell *matHeaderCellDef> Create </th>
                        <td mat-cell *matCellDef="let permission">
                            <mat-checkbox [checked]="permission.create" disabled></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef> Edit </th>
                        <td mat-cell *matCellDef="let permission">
                            <mat-checkbox [checked]="permission.edit" disabled></mat-checkbox>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="permissionColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: permissionColumns;"></tr>
                </table>
            </div>
        </div>

        <!-- Form View -->
        <form *ngIf="isEditMode" class="p-6 bg-card shadow rounded overflow-hidden" [formGroup]="staffForm"
            #staffProfileNgForm="ngForm" (ngSubmit)="onFormSubmit()">
            <h2 class="text-lg sm:text-xl font-semibold text-gray-800 mb-4 border-b pb-2">
                Staff Information
            </h2>
            <div class="grid sm:grid-cols-12 gap-6 w-full mt-8">
                <div class="sm:col-span-6">
                    <mat-label class="font-semibold">Active Status</mat-label>
                    <mat-checkbox class="w-full" formControlName="isActive" color="primary"
                        [(ngModel)]="staffData.Is_Active__c">
                    </mat-checkbox>
                    <mat-error *ngIf="staffForm.get('isActive')?.invalid">
                        Active Check is required
                    </mat-error>
                </div>
                <br>
                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Staff Name</mat-label>
                        <input matInput formControlName="name" (input)="onInputAlphabet($event)" required>
                        <mat-error *ngIf="staffForm.get('name').invalid">
                            Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" type="email" readonly required>
                        <mat-error *ngIf="staffForm.get('email').invalid">
                            Valid email is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="cellPhone" (input)="onInputNumeric($event)" required>
                        <mat-error *ngIf="staffForm.get('cellPhone').invalid">
                            Phone is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Role</mat-label>
                        <mat-select formControlName="role" [disabled]="isEditMode" required>
                            <mat-option *ngFor="let role of roleOptions" [value]="role.key">
                                {{role.value}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="staffForm.get('role').invalid">
                            Role is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Address</mat-label>
                        <input matInput formControlName="address" (input)="onInputAlphanumeric($event)" required>
                        <mat-error *ngIf="staffForm.get('address').invalid">
                            Address is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-col gt-xs:flex-row">
  <h2 class="text-lg sm:text-xl font-semibold text-gray-800 mb-4 border-b pb-2">
    Staff Role Permissions
  </h2>
            <table mat-table [dataSource]="permissionsArray.controls" class="mat-elevation-z2 w-full text-sm">
                <ng-container matColumnDef="feature">
                    <th mat-header-cell *matHeaderCellDef> Feature </th>
                    <td mat-cell *matCellDef="let permission">
                        {{permission.get('feature').value}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="view">
                    <th mat-header-cell *matHeaderCellDef> View </th>
                    <td mat-cell *matCellDef="let permission">
                        <mat-checkbox [formControl]="permission.get('view')"></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="create">
                    <th mat-header-cell *matHeaderCellDef> Create </th>
                    <td mat-cell *matCellDef="let permission">
                        <mat-checkbox [formControl]="permission.get('create')"
                            [disabled]="permission.get('create').disabled"></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef> Edit </th>
                    <td mat-cell *matCellDef="let permission">
                        <mat-checkbox [formControl]="permission.get('edit')"
                            [disabled]="permission.get('edit').disabled"></mat-checkbox>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="permissionColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: permissionColumns;"></tr>
            </table>
            </div>
            <div class="text-center mt-8">
                <button type="button" (click)="toggleEditMode()" mat-raised-button class="mr-2">
                    Cancel
                </button>
                <button type="submit" [disabled]="staffForm.invalid || pageLoader" mat-raised-button color="primary">
                    <span *ngIf="!pageLoader">Update</span>
                    <span *ngIf="pageLoader">Updating...</span>
                </button>
            </div>
        </form>
    </div>
</div>